import StarterKit from "@tiptap/starter-kit";
import { TextStyleKit } from "@tiptap/extension-text-style";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Image from "@tiptap/extension-image";
import { ParagraphFormat } from "./paragraphFormat";

/**
 * TipTap extension set for the day-note editor (ADR-0011).
 *
 * The editor is a Google-Docs-like writing surface: bold / italic / underline /
 * strikethrough / text colour / highlight / links / lists / alignment / indent /
 * line+paragraph spacing / text size / images, plus undo/redo — with a compact
 * togglable toolbar. Headings are intentionally absent: the OT asked for text
 * size instead (semantic H1-H3 no longer exist; legacy <h1..h3> in saved notes
 * flatten to paragraphs, content preserved).
 *
 * Markdown-while-typing stays on (StarterKit input rules): **bold**, *italic*,
 * ~~strike~~, ==highlight==, `- ` bullets, `1. ` lists, and autolinked URLs.
 */
export const noteEditorExtensions = [
  StarterKit.configure({
    heading: false, // text size replaces headings
    blockquote: false,
    code: false,
    codeBlock: false,
    horizontalRule: false,
    link: false, // registered separately with editor-friendly options
  }),
  TextStyleKit.configure({
    fontFamily: false,
    backgroundColor: false, // highlight uses <mark> instead
    lineHeight: false, // line height is paragraph-level via ParagraphFormat
  }),
  Highlight.configure({ multicolor: true }),
  Link.configure({
    openOnClick: false, // don't navigate away while editing; Ctrl/Cmd+click opens
    autolink: true,
    linkOnPaste: true,
    defaultProtocol: "https",
    HTMLAttributes: { rel: "noopener noreferrer", target: "_blank" },
  }),
  TextAlign.configure({ types: ["paragraph"] }),
  Image.configure({
    allowBase64: true, // pasted images are stored inline (downscaled, see pasteImage)
    HTMLAttributes: { class: "note-image" },
  }),
  ParagraphFormat,
];
